module.exports = __webpack_public_path__ + "static/img/xiaoxue.873a6ab8.png";